"use client";

import React from "react";
import { Card, Button } from "antd";
import { PhoneOutlined, UserOutlined, TeamOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";

const SupportContact = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const ContactCard = ({ title, phones, icon: Icon }) => (
    <motion.div variants={itemVariants}>
      <Card
        className="h-full hover:shadow-xl transition-shadow duration-300"
        style={{
          background: "linear-gradient(135deg, #fff 0%, #f0f2f5 100%)",
          border: "1px solid #e8e8e8",
        }}
      >
        <div className="text-center space-y-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 mb-4">
            <Icon style={{ fontSize: 24, color: "#1890ff" }} />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-6">{title}</h3>
          <div className="space-y-3">
            {phones.map((phone, index) => (
              <a
                key={index}
                href={`tel:${phone.replace(/[^0-9]/g, "")}`}
                className="flex items-center justify-center space-x-2 text-lg font-medium text-gray-600 hover:text-blue-500 transition-colors"
              >
                <PhoneOutlined />
                <span>{phone}</span>
              </a>
            ))}
          </div>
          <div className="pt-6">
            <p className="text-gray-500 mb-4">Hoặc</p>
            <Button
              type="primary"
              size="large"
              className="min-w-[200px] bg-blue-500 hover:bg-blue-600"
              icon={<UserOutlined />}
            >
              Đăng ký nhân viên tư vấn
            </Button>
          </div>
        </div>
      </Card>
    </motion.div>
  );

  return (
    <section className="py-16 px-4 bg-gray-50">
      <motion.div
        className="max-w-7xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Hỗ Trợ & Tư Vấn
          </h2>
          <p className="text-gray-600">
            Chúng tôi luôn sẵn sàng hỗ trợ bạn 24/7
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <ContactCard
            title="HỖ TRỢ CHO NGƯỜI TÌM VIỆC"
            phones={["(028)36364884", "0909767810"]}
            icon={UserOutlined}
          />
          <ContactCard
            title="HỖ TRỢ CHO NHÀ TUYỂN DỤNG"
            phones={["(028)36364554", "0902954563"]}
            icon={TeamOutlined}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default SupportContact;
